/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Col, Row, Typography, Form, Spin, Upload, Modal } from "antd";

import styles from "../DocumentSection/style/DocumentSection.module.css";

import axios from "axios";
import { templateAction } from "../Template/state/actions";
import { toolsAction } from "../Tools/state/actions";
import { CompletedPercentage } from "../DocumentSection/components/CompletedPercentage";
import {  ExclamationCircleOutlined } from "@ant-design/icons";
import { TimeLineForERTS } from "./component/TimeLineForERTS";
import { documentAction } from "../DocumentSection/state/actions";

import { ImportErts } from "../DocumentSection/components/ImportErts";
import { ERTSAction } from "./state/action";
import moment from "moment";
import { defaultERTSData } from "../Common/commondata/commonData";
import { ErtsForm } from "./component/ErtsForm";

const { Content } = Layout;
const { Title } = Typography;

function CreateListing(props) {
 
  const dispatch = useDispatch();

  const [confirmModal, setconfirmModal] = useState(false);

  const [optionalIds, setOptionalIds] = useState({
    templateId: null,
    documentSetId: null,
  });
  
  const [fieldEmpty, setFieldIsEmpty] = useState({
    templateType: "",
    ertsType: "67e4f325551c3a9bff7fd62e",
    propertyType: "",
    closingDateType: null,
    priceType: null,
    clientsArray: [],
    showClientListModal: false,
    entityName: "",
    currentlySelectedCorp: {},
    delegateSeller: null,
    property: {},
  });
  const [ertsType, setErtsType] = useState({
    // For Sake of alter the choice in case of Mark Eibner Brokerage
    contractType: "ERTS",
    contractId: "66aa0f8695a14f0a36fc6e12",
  });
  const [file, setFile] = useState({});
  const [fileNametext, setFileNametext] = useState({});

  const { pdfImportLoading, CurrentPdfImportData } = useSelector((state) => state.documentSection.urlImportReducer);
  let handlePropSearchModel = () => {
    props?.setState((prev) => ({ ...prev, propertySearch: !props?.state?.propertySearch }));
  };
useEffect(()=>{
  if(confirmModal){
  Modal.confirm({
    title: CurrentPdfImportData?.checkDuplicate?.message,
    okText: "Yes",
    cancelText: "No",
    icon: <ExclamationCircleOutlined />,
    //   content: "Note: This will also remove all the signers associated with it.",
    onOk() {
      setconfirmModal(false);
    },
    onCancel() {
      props?.handleCancelErts();
    },
  });
}
},[confirmModal])
  
  const handleImport = () => {
    props?.setState((prev) => ({ ...prev, importErts: true,ReImportErts:false,manualEntry:false }));
    props?.form.resetFields();
    dispatch(documentAction.resetCorpState());
setFieldIsEmpty({
  templateType: "",
  ertsType: "67e4f325551c3a9bff7fd62e",
  propertyType: "",
  closingDateType: null,
  priceType: null,
  clientsArray: [],
  showClientListModal: false,
  entityName: "",
  currentlySelectedCorp: {},
  delegateSeller: null,
  property: {},
})
  };
  const handleManualEntry = () => {
  
    props?.setState((prev) => ({ ...prev, importErts: false,ReImportErts:false,manualEntry:true}));
    props?.form.resetFields();
    props?.resetFormFeilds()
    dispatch(documentAction.resetImportData());
    props?.setListingModalFields({
      ...defaultERTSData({ moment }),
    });
   
    setFile({});
    setFileNametext({});
    dispatch(documentAction.resetCorpState());
   dispatch(documentAction.resetSearchProperties());
     setFieldIsEmpty({
         ...props?.fieldEmpty,
         property: null,
         propertyType: "",
         priceType: "",
         price: "",
        });
       setOptionalIds({ documentSetId: null, templateId: null });

  };
  useEffect(() => {
    if (props.networkConnection === false) {
      window.location.reload();
    }
  }, [props]);

  let sourceAxios = axios.CancelToken.source();
  let unmounted = {
    value: false,
  };

  useEffect(() => {
    dispatch(documentAction.getDocumentData());
    if (!props?.delegate) {
      dispatch(templateAction.gettemplateData({ contractType: "createOfferContractTypes" }));
      dispatch(toolsAction.getDocSetData({ sourceAxios, unmounted, onlyTitle: true }));
    }
    return () => {
      unmounted.value = true;
      sourceAxios.cancel("Cancelling in cleanup");
    };
  }, []);

  useEffect(() => {
    const delegateOwnerId = props?.fieldEmpty?.delegateSeller?.id;
    if (props?.delegate && delegateOwnerId) {
      dispatch(templateAction.gettemplateData({ contractType: "createOfferContractTypes", delegateOwnerId }));
      dispatch(toolsAction.getDocSetData({ sourceAxios, unmounted, onlyTitle: true, delegateOwnerId }));
    }
    return () => {
      unmounted.value = true;
      sourceAxios.cancel("Cancelling in cleanup");
    };
  }, [props?.fieldEmpty?.delegateSeller]);
  const uploadTemp = (createErts) => {
    const data = {
      file,
      createErts: false,
      setconfirmModal,
    };
    props?.setState((prev) => ({
      ...prev,
      importErts: false,
      ReImportErts:true
    }));
    dispatch(ERTSAction.uploadERTSFile(data));
  };
  useEffect(() => {
    if (!CurrentPdfImportData || Object.keys(CurrentPdfImportData).length === 0) {
      return; // Don't run if the object is empty
    }

    

    props.form.setFieldsValue({
      price: CurrentPdfImportData?.PurchasePrice || "",
      startPeriod: CurrentPdfImportData?.ListingPeriodBeginDate ? moment(CurrentPdfImportData.ListingPeriodBeginDate, "YYYY-MM-DD") : null,
      endPeriod: CurrentPdfImportData?.ListingPeriodEndByDate ? moment(CurrentPdfImportData.ListingPeriodEndByDate, "YYYY-MM-DD") : null,
      StreetNumber: CurrentPdfImportData?.StreetNumber || "",
      DirPrefix: CurrentPdfImportData?.DirPrefix || "",
      DirSuffix: CurrentPdfImportData?.DirSuffix || "",
      StreetName: CurrentPdfImportData?.StreetName || "",
      StreetSuffix: CurrentPdfImportData?.StreetSuffix || "",
      UnitLabel: CurrentPdfImportData?.UnitLabel || "Unit",
      UnitNumber: CurrentPdfImportData?.UnitNumber || "",
      City: CurrentPdfImportData?.City || "",
      State: CurrentPdfImportData?.State || "",
      ZipCode: CurrentPdfImportData?.ZipCode || "",
    });

    props?.setListingModalFields({
      ...props?.listingModalFields,
      startPeriod: CurrentPdfImportData?.ListingPeriodBeginDate ? moment(CurrentPdfImportData.ListingPeriodBeginDate, "YYYY-MM-DD") : null,
      endPeriod: CurrentPdfImportData?.ListingPeriodEndByDate ? moment(CurrentPdfImportData.ListingPeriodEndByDate, "YYYY-MM-DD") : null,
      StreetNumber: CurrentPdfImportData?.StreetNumber || "",
      DirPrefix: CurrentPdfImportData?.DirPrefix || "",
      DirSuffix: CurrentPdfImportData?.DirSuffix || "",
      StreetName: CurrentPdfImportData?.StreetName || "",
      StreetSuffix: CurrentPdfImportData?.StreetSuffix || "",
      UnitLabel: CurrentPdfImportData?.UnitLabel || "Unit",
      UnitNumber: CurrentPdfImportData?.UnitNumber || "",
      City: CurrentPdfImportData?.City || "",
      State: CurrentPdfImportData?.State || "",
      ZipCode: CurrentPdfImportData?.ZipCode || "",
    });
  }, [CurrentPdfImportData]);

  return (
    <>
       {/* <span>{confirmModal && handleConfirm()}</span> */}
      <Layout style={{ minHeight: "100%", padding: "0px", marginTop: "-10px" }}>
        <Content>
          <Row
            gutter={[12, 24]}
            style={{
              height: "100%",
            }}
          >
            <Col xs={24} sm={24} md={7} lg={6} xl={6}>
              <div
                className={styles.documentContainer}
                style={{
                  height: "100%",
                }}
              >
                <div
                  style={{
                    border: "1px solid  rgba(0,0,0,0.2)",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                    transition: "0.3s",
                    padding: "0.5rem 0.5rem 0.5rem 1rem",
                    height: "100%",
                  }}
                >
                  <div>
                    <Title level={3}>Steps</Title>
                  </div>
                  <div className={styles.stepBox}>
                    <div>
                      <TimeLineForERTS delegate={props?.delegate} handlePropSearchModel={handlePropSearchModel} fieldEmpty={fieldEmpty} setFieldIsEmpty={setFieldIsEmpty} source={"Listing"} handleImport={handleImport} state={props?.state} setState={props?.setState} handleManualEntry={handleManualEntry} />
                    </div>
                    <div className={styles.percentageCircle}>
                      <CompletedPercentage progress={props?.progress} />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={17} lg={18} xl={18}>
              <div className="offer_screenForm documentFormContainer" style={{ height: "70vh", overflowY: "auto" }}>
                {pdfImportLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center", // horizontal centering
                      alignItems: "center", // vertical centering
                      height: "100%", // or any fixed height
                    }}
                  >
                    <Spin />
                  </div>
                ) : props?.state?.importErts ? (
                  <ImportErts file={file} setFile={setFile} fileNametext={fileNametext} setFileNametext={setFileNametext} uploadTemp={uploadTemp} confirmModal={confirmModal} setconfirmModal={setconfirmModal} ertsType={ertsType} setErtsType={setErtsType} state={props?.state} setState={props?.setState} />
                ) : (
                  <ErtsForm
                    source={"Listing"}
                    setProgress={props?.setProgress}
                    progress={props?.progress}
                    redirectFromClient={props}
                    delegate={props?.delegate}
                    setisModalOpen={props?.setisModalOpen}
                    form={props?.form}
                    fieldEmpty={fieldEmpty}
                    setFieldIsEmpty={setFieldIsEmpty}
                    uploadTemp={uploadTemp}
                    handlePropSearchModel={handlePropSearchModel}
                    handleCancelErts={props?.handleCancelErts}
                    listingModalFields={props?.listingModalFields}
                    setListingModalFields={props?.setListingModalFields}
                    addPersons={props?.addPersons}
                    addCorps={props?.addCorps}
                    setAddPerson={props?.setAddPerson}
                    setAddCorps={props?.setAddCorps}
                    docsModal={props?.docsModal}
                    handleImport={handleImport}
                    confirmModal={confirmModal}
                    setconfirmModal={setconfirmModal}
                    ertsType={ertsType}
                    setErtsType={setErtsType}
                    state={props?.state}
                    setState={props?.setState}
                    setFileNametext={setFileNametext}
                    setFile={setFile}
                    file={file}
                    fileNametext={fileNametext}
                    optionalIds={optionalIds}
                    setOptionalIds={setOptionalIds}
                  />
                )}
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
}
export { CreateListing };
